import {initElements} from "../define/shared"

export default function initMediaPage() {
    initElements(".mediaPage", page => {
        const categories = [].slice.apply(page.querySelectorAll('.mediaPage-categories a')),
            images = [].slice.apply(page.querySelectorAll('.category-image')),
            fullscreen = page.querySelector('.mediaPage-fullscreen'),
            fullscreenButtons = {
                close: fullscreen.querySelector('.icon-close'),
                download: fullscreen.querySelector('.icon-download')
            }

        categories.forEach(cat => {
            cat.addEventListener('click', e => {
                e.preventDefault()
                categories.forEach(item => {
                    item.classList.remove('is--active')
                })
                cat.classList.add('is--active')
                window.scrollTo({
                    left: 0,
                    top: document.querySelector(cat.getAttribute('href')).offsetTop - 60,
                    behavior: "smooth"
                })
            })
        })

        images.forEach(image => {
            image.addEventListener('click', () => {
                fullscreen.querySelector('img').src = image.dataset.imageFull
                fullscreen.querySelector('a').href = image.dataset.imageFull
                setTimeout(()=>{
                    fullscreen.classList.add('is--open')
                }, 50)
            })
        })

        fullscreenButtons.close.addEventListener('click', () => {
            fullscreen.classList.remove('is--open')
        })

    })
}
